// extracted by mini-css-extract-plugin
export default {"switch-fund-btn":"otpmodal_switch-fund-btn__lqQVG","SIPCloseicon":"otpmodal_SIPCloseicon__btE5b","SIPButtons":"otpmodal_SIPButtons__uEg+Y"};